import noFavIcon from "@/img/icon-fav-empty.svg";
import favIcon from "@/img/icon-fav-full.svg";
import { useFavorites } from "@/hooks/use-favorites";

import "./style.scss";

type FavCityButtonProps = {
	locationNameEn: string;
	locationNameAr: string;
	locationId: string;
	showFavEmpty: boolean;
	isDisabled: boolean;
};

export const FavCityButton = ({
	locationId,
	locationNameEn,
	locationNameAr,
	showFavEmpty,
	isDisabled,
}: FavCityButtonProps) => {
	const { handleToggleFavorites, isFavorite } = useFavorites();

	return (
		<div
			className="fav-button"
			onClick={() =>
				isDisabled
					? null
					: handleToggleFavorites({
							id: locationId,
							nameEn: locationNameEn,
							nameAr: locationNameAr,
					  })
			}
		>
			{isFavorite(locationId) ? (
				<img src={favIcon} alt="fav icon" className="fav-city" />
			) : (
				showFavEmpty && (
					<img src={noFavIcon} alt="fav icon" className="no-fav-city" />
				)
			)}
		</div>
	);
};

export default FavCityButton;
